import { useEffect } from 'react';

import { useDisplayMode } from '../useDisplayMode';

interface Props {
  sentryRelease: string;
}

const usePWAReloadCheck = ({ sentryRelease }: Props) => {
  const displayMode = useDisplayMode();

  useEffect(() => {
    // only check in standalone mode (PWA)
    if (displayMode !== 'standalone') return;

    if (sentryRelease !== window.__AppGlobals__?.SENTRY_RELEASE) {
      console.log(
        `Reloading page due to new release. Old release: ${window.__AppGlobals__?.SENTRY_RELEASE}, New release: ${sentryRelease}`,
      );
      window.location.reload();
    }
  }, [sentryRelease, displayMode]);
};

export default usePWAReloadCheck;
